import { render, staticRenderFns } from "./CustomCssEditor.vue?vue&type=template&id=4b27876e&scoped=true"
import script from "./CustomCssEditor.vue?vue&type=script&lang=js"
export * from "./CustomCssEditor.vue?vue&type=script&lang=js"
import style0 from "./CustomCssEditor.vue?vue&type=style&index=0&id=4b27876e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b27876e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b27876e')) {
      api.createRecord('4b27876e', component.options)
    } else {
      api.reload('4b27876e', component.options)
    }
    module.hot.accept("./CustomCssEditor.vue?vue&type=template&id=4b27876e&scoped=true", function () {
      api.rerender('4b27876e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/helper/CustomCssEditor.vue"
export default component.exports